import type { DeviceConfigSnapshot } from "./admin";

export type DeviceConfigSnapshotPayload = Omit<DeviceConfigSnapshot, "configRevision" | "snapshotHash">;

export function deviceConfigSnapshotPayload(snapshot: DeviceConfigSnapshot | DeviceConfigSnapshotPayload): DeviceConfigSnapshotPayload {
  return {
    store: snapshot.store,
    settings: snapshot.settings,
    menu: snapshot.menu,
    operators: snapshot.operators,
    device: snapshot.device,
  };
}

export async function hashDeviceConfigSnapshot(snapshot: DeviceConfigSnapshot | DeviceConfigSnapshotPayload): Promise<string> {
  const encoded = new TextEncoder().encode(JSON.stringify(deviceConfigSnapshotPayload(snapshot)));
  const digest = await crypto.subtle.digest("SHA-256", encoded);
  let binary = "";
  for (const byte of new Uint8Array(digest)) binary += String.fromCharCode(byte);
  return btoa(binary);
}
